import { FC, useEffect, useRef } from 'react';
import { CollapseProps } from './types';

/**
 *  UI Component
 */
const Collapse: FC<CollapseProps> = function Collapse(props) {
  const {
    children,
    show,
    duration = 300,
    unmountOnHide,
    grow,
    ...rest
  } = props;
  const wrapperRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);
  const growRef = useRef<HTMLDivElement>(null);
  const domTimerRef = useRef<NodeJS.Timeout>();
  const timerRef = useRef<NodeJS.Timeout>();
  const openRef = useRef<boolean | undefined>(show);

  // TODO: solve unmount issue
  // const [, setIdle] = useState(true);

  useEffect(() => {
    // setIdle(false);
    if (!wrapperRef.current || !innerRef.current) return;
    clearTimeout(domTimerRef.current);
    clearTimeout(timerRef.current);

    if (show === openRef.current && !show) {
      wrapperRef.current.style.maxHeight = '0px';
      wrapperRef.current.style.overflow = 'hidden';
      return;
    }
    openRef.current = show;
    if (show) {
      wrapperRef.current.style.transition = '';
      wrapperRef.current.style.overflow = 'hidden';

      wrapperRef.current.style.maxHeight = '0px';
      innerRef.current.style.opacity = '0';
      innerRef.current.style.position = 'absolute';
      wrapperRef.current.style.transition = `max-height ${duration}ms ease-out`;

      if (grow && growRef.current) {
        growRef.current.style.transition = '';
        growRef.current.style.transform = 'scale(0,0)';
        growRef.current.style.transition = `transform ${
          duration * 1.25
        }ms ease-out`;
      }
      domTimerRef.current = setTimeout(() => {
        const bounds = innerRef.current?.getBoundingClientRect();
        if (!bounds || !wrapperRef.current) return;
        innerRef.current?.style.removeProperty('opacity');
        innerRef.current?.style.removeProperty('position');

        wrapperRef.current.style.maxHeight = `${bounds.height}px`;
        if (grow && growRef.current) {
          growRef.current.style.transform = 'scale(1,1)';
        }
      }, 50);
      timerRef.current = setTimeout(() => {
        wrapperRef.current?.style.removeProperty('transition');
        wrapperRef.current?.style.removeProperty('max-height');
        wrapperRef.current?.style.removeProperty('overflow');
        // setIdle(true);
      }, duration);
    } else {
      wrapperRef.current.style.maxHeight = `${
        wrapperRef.current.getBoundingClientRect().height
      }px`;
      wrapperRef.current.style.transition = `max-height ${duration}ms ease-out`;
      domTimerRef.current = setTimeout(() => {
        if (!wrapperRef.current) return;
        wrapperRef.current.style.overflow = 'hidden';
        wrapperRef.current.style.maxHeight = '0px';
        if (grow && growRef.current) {
          growRef.current.style.transition = `transform ${
            duration * 0.75
          }ms ease-out`;
          growRef.current.style.transform = 'scale(0,0)';
        }
      }, 50);
      // timerRef.current = setTimeout(() => {
      //   setIdle(true);
      // }, duration);
    }
  }, [show, duration, grow]);

  // const content = !show && unmountOnHide && idle ? <></> : children;
  return (
    <div
      ref={wrapperRef}
      style={{ overflow: 'hidden', maxHeight: '0' }}
      {...rest}
    >
      <div ref={innerRef}>
        {grow ? <div ref={growRef}>{children}</div> : children}
        {/* {!show && unmountOnHide && idle ? <></> : children}*/}
      </div>
    </div>
  );
};

export default Collapse;
